
import React, { useEffect, useState, forwardRef, useRef } from "react";
// import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions, Container, Popover,
    TablePagination, Typography, InputAdornment, IconButton, Tooltip, DialogContent, Divider, Snackbar
} from '@mui/material';
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Icon } from '@iconify/react';
import EditIcon from '@mui/icons-material/Edit';
import { SearchOutlined } from '@mui/icons-material';
// import { downloadExcel } from 'react-export-table-to-excel';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CloseIcon from '@mui/icons-material/Close';
import Breadcrumb from "../../reusableComponent/Breadcrumb";
import { StyledTableRow, StyledTableCell } from '../../reusableComponent/StyledTable'
import {BackBtn} from "../../reusableComponent/BackBtn";
import { useDispatch, useSelector } from "react-redux";
import { editDeleteCNS, getCNSList, uploadCNSExcel } from "../../../actions/actions";
import { dateConversionOnEntryPage } from "../../reusableComponent/dateConversionOnEntryPage";
import AddIcon from '@mui/icons-material/Add';
import { BootstrapDialog, BootstrapDialogTitle } from "../../reusableComponent/BootstrapDialog";
import styles from '.././../../styles.module.css';
import ExcelDownload from "../../reusableComponent/ExcelDownload";
import upload_excel from '../../../images/upload_excel.png'
import PartiesAdd from "./PartiesAdd";
import PartiesDetails from "./PartiesDetails";
import { fileDownloadURL } from "../../../fileDownloadURL";

function PartiesList(props) {
    const dispatch = useDispatch();
    const [successMessage, setSuccessMessage] = useState(null);

    let ref = useRef();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const [openPopup, setOpenPopup] = React.useState(false);
    const [info, setInfo] = useState({});
    const [open, setOpen] = React.useState();
    const [openOption, setOpenOption] = useState('');
    const fileInputRef = useRef(null);

    const handleClickOpenPopup = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption(info.id ? 'PartyUpdate' : 'PartyAdd')
    };
    const tableRef = useRef(null);
    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [page, setPage] = React.useState(0)

    const handleClickOpen = () => {
        setOpen(true);

    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    const [isLoaded, setIsLoaded] = useState(false);

    const [q, setQ] = useState("");
    const [searchParam] = useState(["CNS_Name", "accountName", "accountNumber", "accountType", "address", "bankName", "branchCode", "branchName", "city", "contactPerson", "creditLimit", "creditPeriod", "emailId", "gstn", "ifscCode", "mobileNo", "panNo", "pinCode", "state", "supplierType", "balanceType", "vendorCode"]);

    const fields = ['CSNId', 'CNS_Name', 'CNS_Type', 'supplierType', 'contactPerson', 'mobileNo', 'emailId', 'gstn', 'panNo', 'creditLimit', 'openingBalance', 'creditPeriod', 'vendorCode', 'address', 'city', 'state', 'pinCode', 'CNS_JoiningDate', 'balanceType', 'bankName'];
    const labels = ['Id', 'Party Name', 'Partie Type', 'Supplier Type', 'Contact Person', 'Mobile No', 'Email Id', 'GSTN', 'PAN No', 'Credit Limit', 'Opening Balance', 'Credit Period', 'Vendor Code', 'Address', 'City', 'State', 'Pin Code', 'Joining Date', 'Balance Type', 'Bank Name'];

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();

    const rows = useSelector(state => state.CNS.CNS)
    const fetchData = () => {
        dispatch(getCNSList({financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: 'All' }))
    };
    useEffect(() => {
        fetchData()
    }, []);
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.CNS.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'Party name already available!') {
                    setOpenPopup(true);
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                } else {
                    setSuccessMessage(responseMessage);
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
                    fetchData();
                    setIsDelete(false);
                    setOpenPopup(false);
                }
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);

    const handleUpload = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        const formData = new FormData();

        // Append additional fields to formData
        formData.append('companyId', userInfo.companyId);
        formData.append('createdBy', userInfo.userId);
        formData.append('createdAt', dateConversionOnEntryPage(new Date()));

        // Append the selected file
        formData.append('file', selectedFile);

        selectedFile !== '' &&
            dispatch(uploadCNSExcel(formData));
    };

    const deleteRecord = (id) => {
        dispatch(editDeleteCNS({ id: id, modifiedBy: userInfo.userId, modifiedAt: dateConversionOnEntryPage(new Date()), changedUpdatedValue: 'delete' }))
        setIsDelete(false);
        fetchData()
    }

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
        setOpen(false);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
        setOpen(false);
        setOpenPopup(false);
    };

    function search() {
        return rows && rows.filter((item) => {
            return searchParam.some((newItem) => {
                return (
                    item[newItem] && item[newItem]
                        .toString()
                        .toLowerCase()
                        .indexOf(q.toLowerCase()) > -1
                );
            });
        });
    }
    const [sortBy, setSortBy] = useState(null);
    const handleSort = (property) => {
        const isAsc = sortBy === property && sortBy !== null;
        setSortBy(isAsc ? property + '_desc' : property);
        rows.sort((a, b) => {
            if (typeof a[property] === 'number' && typeof b[property] === 'number') {
                return isAsc ? a[property] - b[property] : b[property] - a[property];
            } else {
                return isAsc ? a[property].localeCompare(b[property]) : b[property].localeCompare(a[property]);
            }
        });
    };

    const handleDetails = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption('PartieDetails')
    }

    const handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage(false)
    };

    const actionMsg = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <>
           <Breadcrumb
                        routeSegments={[
                            { name: 'Masters', path: '/masters/' },
                            { name: 'Party List' },
                        ]}
                    />
            <Paper className={`${styles.list_container}`}>
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid item md={7} xs={4}>

                        </Grid>
                        <Grid item md={5} xs={8} style={{ display: 'flex', }}>
                            <Box className={`${styles.excel_box}`}>
                                <ExcelDownload
                                    data={rows}
                                    fields={fields}
                                    labels={labels}
                                    filename="Parties List"
                                />
                            </Box>
                            <Box className={`${styles.excel_box}`}>
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    name="file"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                />
                                <Tooltip title="Upload Excel File">
                                    <span onClick={handleUpload} htmlFor="file-upload"> <img src={upload_excel} style={{ height: "20px", width: "20" }} /> </span>
                                </Tooltip>
                            </Box>
                            <TextField
                                fullWidth
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 25,
                                        fontSize: '11px',
                                        paddingLeft: '1px',
                                    }
                                }}
                                type="search"
                                name="search"
                                placeholder="Search"
                                value={q}
                                size="small"
                                onChange={(e) => setQ(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" >
                                            <IconButton sx={{ padding: '4px' }}>
                                                <SearchOutlined className={`${styles.search_icon}`} />
                                                <Divider orientation="vertical" flexItem />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <NavLink to={{ pathname: `/masters/add-party-masters` }} className={`${styles.underline}`}>
                                <Button variant="contained" className={`${styles.add_btn}`}>
                                    <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Create New
                                </Button>
                            </NavLink>
                        </Grid>
                        <Grid item md={12} >
                            <a href={`${fileDownloadURL}SampleFileParty.csv`}
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                            >
                                <Typography className={`${styles.erp_lable}`} style={{ textDecoration: 'underline', display: 'flex', float: 'right' }}> Download Sample File </Typography>
                            </a>
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('CNS_Name')}>Party Name<span className={`${styles.sort_icon}`}> {sortBy === 'CNS_Name' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('contactPerson')}>Party Type<span className={`${styles.sort_icon}`}> {sortBy === 'CNS_Type' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('contactPerson')}>Contact Person<span className={`${styles.sort_icon}`}> {sortBy === 'contactPerson' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('mobileNo')}>Mobile No<span className={`${styles.sort_icon}`}> {sortBy === 'mobileNo' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('emailId')}>E-mail Id<span className={`${styles.sort_icon}`}> {sortBy === 'emailId' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('gstn')}>GST No<span className={`${styles.sort_icon}`}> {sortBy === 'gstn' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('panNo')}>PAN No<span className={`${styles.sort_icon}`}> {sortBy === 'panNo' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('totalPayable')}>Total Receivable/Payable<span className={`${styles.sort_icon}`}> {sortBy === 'totalPayable' ? '▲' : '▼'} </span></StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {rows && search(rows)
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                .map((row, index) => (
                                    <StyledTableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <StyledTableCell align="center" >
                                            <PopupState variant="popover" popupId="demo-popup-popover">
                                                {(popupState) => (
                                                    <div>
                                                        <MoreHorizIcon
                                                            id={styles.actionBtn}
                                                            alt="translator"
                                                            variant="contained"
                                                            {...bindTrigger(popupState)}
                                                        />
                                                        <Popover
                                                            {...bindPopover(popupState)}
                                                            anchorOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                            transformOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                        >
                                                            <Container className={`${styles.tbl_action}`}>
                                                                <>
                                                                    <NavLink to={{ pathname: `/masters/add-party-masters` }} state={row} className={`${styles.underline}`}>
                                                                        <Button className={`${styles.list_tbl_action_btn}`} >
                                                                            <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} />
                                                                            <span style={{ marginRight: '13px' }}> Edit Record</span> </Button>
                                                                    </NavLink>
                                                                    <Button className={`${styles.list_tbl_action_btn}`} onClick={() => { handleDelete(row); popupState.close()}}>
                                                                        <Icon icon="ic:baseline-delete-forever" color="#c70000" width="20" height="20" /> Delete Record</Button>
                                                                </>
                                                            </Container>
                                                        </Popover>
                                                    </div>
                                                )}
                                            </PopupState>
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`} sx={{ color: 'blue' }} onClick={() => handleDetails(row)}>
                                            <span style={{ cursor: 'pointer', color: 'blue' }} > {row.CNS_Name}</span>
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.CNS_Type}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.contactPerson}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.mobileNo}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.emailId}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.gstn}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.panNo}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}> {row.CNS_Type === 'Customer' ? parseFloat(row.totalReceivable).toFixed(2) : parseFloat(row.totalPayable).toFixed(2)}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    sx={{ px: 2 }}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <Dialog open={isDelete}
                PaperProps={{
                    sx: {
                        minWidth: "35%",
                        minHeight: "22%",
                        borderRadius: '8px'
                    }
                }}>
                <DialogTitle className={`${styles.dilog_delete_title}`}>
                    Confirm Delete The Record?
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            right: 0,
                            top: 0,
                            float: 'right'
                        }} >
                        <CloseIcon style={{ height: '18px', color: '#000000' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={`${styles.dilog_delete_content}`}>
                    The BillCube will remove this record # {deleteInfo && deleteInfo.CNS_Name}
                </DialogContent>
                <DialogActions sx={{ padding: '10px', }}>
                    <Button onClick={handleClose} className={`${styles.dilog_delete_no_btn}`} variant='outlined'>
                        No
                    </Button>
                    <Button onClick={() => deleteRecord(deleteInfo.CSNId)} className={`${styles.dilog_delete_yes_btn}`} variant='outlined'>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <BootstrapDialog
                PaperProps={{
                    sx: {
                        maxWidth: "75%",
                        maxHeight: 600,
                        minWidth: "80%",
                        minHeight: 120
                    }
                }}
                onClose={handleClose}
                open={openPopup}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    {openOption === 'PartyAdd' && 'Create Party'}
                    {openOption === 'PartyUpdate' && 'Update Party'}
                    {openOption === 'PartieDetails' && 'Party Details'}
                </BootstrapDialogTitle>
                <DialogContent dividers >
                    {(openOption === 'PartyUpdate' || openOption === 'PartyAdd') &&
                        <PartiesAdd handleCloseDialog={handleClose} details={info} CNSTYPE={'All'} onAPISubmt={fetchData} />
                    }
                    {openOption === 'PartieDetails' &&
                        <PartiesDetails details={info} />
                    }
                </DialogContent>
            </BootstrapDialog>

            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={2000}
                    onClose={handleCloseSuccessMsg}
                    message={successMessage}
                    action={actionMsg}
                />
            }
        </>
    )
}

export default PartiesList